import { render, staticRenderFns } from "./UploadStock.vue?vue&type=template&id=8ea857be&scoped=true&"
import script from "./UploadStock.vue?vue&type=script&lang=js&"
export * from "./UploadStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea857be",
  null
  
)

export default component.exports